import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/klickanleitungen.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/klickanleitungen')({
  component: Content,
});
